import { render, staticRenderFns } from "./DormKpiBoard.vue?vue&type=template&id=520a49bb&scoped=true"
import script from "./DormKpiBoard.vue?vue&type=script&lang=js"
export * from "./DormKpiBoard.vue?vue&type=script&lang=js"
import style0 from "./DormKpiBoard.vue?vue&type=style&index=0&id=520a49bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a49bb",
  null
  
)

export default component.exports